(function () {
  const subtitles = {
    "Wood Flooring": "Engineered, Plank & Parquet",
    "Trims & Thresholds": "Profiles, Edging & Transitions",
    "Cleaning & Maintenance": "Cleaners, Oils & Care Products",
    "Sanding & Finishing": "Abrasives, Fillers & Finishes",
    "Floor Preparation & Installation": "Levellers, Adhesives, DPMs & Underlays",
    "Tools & Equipment": "Hand Tools, Power Tools & PPE",
    "Brands": "Shop All Our Brands",
    "Special Offers": "View Our Latest Deals"
  };

  function upgradeMenu() {
    document
      .querySelectorAll(
        ".main-nav > li > details > summary > a.main-nav__item--primary, .main-nav > li > a.main-nav__item--primary"
      )
      .forEach(function (link) {
        if (link.querySelector(".wwfs-menu-title-wrap")) return;

        const cleanText = link.textContent.replace(/\s+/g, " ").trim();
        const title = Object.keys(subtitles).find(function (name) {
          return cleanText.startsWith(name);
        });

        if (!title) return;

        Array.from(link.childNodes).forEach(function (node) {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            node.remove();
          }
        });

        const wrap = document.createElement("span");
        wrap.className = "wwfs-menu-title-wrap";
        wrap.innerHTML =
          '<span class="wwfs-menu-title">' +
          title +
          "</span>" +
          '<span class="wwfs-menu-subtitle">' +
          subtitles[title] +
          "</span>";

        link.insertBefore(wrap, link.firstChild);
      });
  }

  function closeAccountMenus(exceptMenu) {
    document.querySelectorAll(".wwfs-account-menu[open]").forEach(function (menu) {
      if (menu !== exceptMenu) {
        menu.removeAttribute("open");
      }
    });
  }

  function ensureCartCount() {
    const bubble = document.getElementById("cart-icon-bubble");
    if (!bubble) return;

    const currentCount = bubble.querySelector(".header__cart-count");
    if (currentCount) {
      currentCount.classList.add("wwfs-cart-count");
      return;
    }

    const count = document.createElement("span");
    count.className = "header__cart-count wwfs-cart-count";
    count.innerHTML =
      '<span aria-hidden="true" class="header__cart-count-number">0</span>' +
      '<span class="visually-hidden">0 items in cart</span>';
    bubble.appendChild(count);
  }

  function upgradeHeader() {
    upgradeMenu();
    ensureCartCount();
  }

  document.addEventListener("DOMContentLoaded", upgradeHeader);

  document.addEventListener("click", function (event) {
    const openAccountMenu = event.target.closest(".wwfs-account-menu");
    if (!openAccountMenu) {
      closeAccountMenus();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;

    const openMenu = document.querySelector(".wwfs-account-menu[open]");
    if (!openMenu) return;

    openMenu.removeAttribute("open");
    const trigger = openMenu.querySelector("summary");
    if (trigger) trigger.focus();
  });

  document.addEventListener("shopify:section:load", function (event) {
    if (
      event.target.matches("store-header, .shopify-section-group-header-group") ||
      event.target.querySelector("store-header")
    ) {
      upgradeHeader();
    }
  });
})();
